package devxertech.com.pages.blogs.blogPages


import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.justifyContent
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.JustifyContent
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Composable
fun BusinessUsageWithAI() {
    val palette = ColorMode.current.toSitePalette()
    val breakpoint = rememberBreakpoint()

    Row(
        modifier = Modifier
            .fillMaxWidth()
            .alignItems(AlignItems.Center)
            .gap(if (breakpoint < Breakpoint.MD) 0.px else 40.px)
            .flexWrap(FlexWrap.Wrap),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        // Left Column - Text Content
        Column(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint < Breakpoint.MD) 100.percent else if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG)
                    93.percent else 31.percent)
                .padding(leftRight = 20.px)
        ) {
            // Title Section
            Row(
                modifier = Modifier.gap(6.px).padding(bottom = 25.px),
                horizontalArrangement = Arrangement.Start,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Image(
                    src = Res.Image.blog_arrow,
                    modifier = Modifier
                        .size(15.px)
                        .color(palette.topBarMenuText.rgb)
                        .margin(bottom = if (breakpoint < Breakpoint.MD) 25.px else if (window.screen.width in 1400..1889) 27.px else 0.px)
                )
                SpanText(
                    text = "How Are Businesses Actually Using AI in 2025?",
                    modifier = Modifier
                        .fontSize(if (window.screen.width > 1600) 24.px else 20.px)
                        .fontWeight(FontWeight.Bold)
                        .color(palette.topBarMenuText.rgb)
                )
            }

            // AI Use Cases
            AiSection(
                title = "Retail & E-Commerce",
                points = listOf(
                    "AI recommends products based on customer behavior",
                    "Smart inventory systems reduce stockouts and overstock",
                    "Chatbots offer 24/7 support with human-like responses"
                )
            )
            AiSection(
                title = "Healthcare",
                points = listOf(
                    "AI assists in early diagnosis through image analysis",
                    "Predictive models forecast disease progression",
                    "Virtual assistants support doctors in treatment planning"
                )
            )
            AiSection(
                title = "Finance",
                points = listOf(
                    "Fraud detection systems use AI to monitor transaction patterns",
                    "Robo-advisors provide investment suggestions",
                    "Credit scoring becomes faster and more accurate using alternative data"
                )
            )
            AiSection(
                title = "Manufacturing",
                points = listOf(
                    "AI predicts machinery failures before they happen",
                    "Robotic systems handle high-precision tasks",
                    "Smart quality checks ensure defect-free production"
                )
            )
            AiSection(
                title = "Marketing & Sales",
                points = listOf(
                    "AI tools write personalized email content",
                    "Predictive analytics suggest best-performing campaigns",
                    "Sales teams use AI to prioritize high-converting leads"
                )
            )
        }

        // Right Column - Image
        Box(
            modifier = Modifier
                .fillMaxWidth(if (breakpoint < Breakpoint.MD) 100.percent else
                    if (breakpoint == Breakpoint.MD || breakpoint == Breakpoint.LG) 50.percent else 32.percent)
                .display(DisplayStyle.Flex)
                .justifyContent(JustifyContent.Center)
                .alignItems(AlignItems.Center)
        ) {
            Image(
                src = Res.Image.blog_community,
                modifier = Modifier.width(if (breakpoint < Breakpoint.MD) 90.percent else 100.percent)
            )
        }
    }
}

@Composable
private fun AiSection(title: String, points: List<String>) {
    val palette = ColorMode.current.toSitePalette()

    Column(modifier = Modifier.margin(bottom = 25.px, leftRight = 20.px)) {
        // Section Title
        SpanText(
            text = title,
            modifier = Modifier
                .color(palette.primary.rgb)
                .fontWeight(FontWeight.SemiBold)
                .fontSize(if (window.screen.width > 1600) 22.px else 18.px)
                .margin(bottom = 8.px)
        )

        // Bullet Points
        Column {
            points.forEach { point ->
                Row(modifier = Modifier.margin(bottom = 6.px)) {
                    SpanText(
                        text = "•",
                        modifier = Modifier.color(palette.commonSecondaryButtonColor.rgb).margin(right = 4.px)
                    )
                    SpanText(
                        text = point,
                        modifier = Modifier
                            .fontSize(if (window.screen.width > 1600) 18.px else 14.px)
                            .fontFamily(Constants.FONT_FAMILY)
                            .lineHeight(1.5)
                            .color(palette.commonSecondaryButtonColor.rgb)
                    )
                }
            }
        }
    }
}
